import { toDateTypeLy } from '@/pages/intelligence/utils/common';

export const normalizeMetricSearchDateGranularity = (dateType = '') =>
  toDateTypeLy[dateType] || dateType || 'monthly';

/** 与 getDateScopedAllMetricsOptions 保持一致：无 dateEnum 时不禁用 */
export const isMetricSearchOptionDisabled = (
  option: { dateEnum?: string[] },
  dateGranularityType = '',
): boolean => {
  const normalizedGranularity = normalizeMetricSearchDateGranularity(dateGranularityType);
  if (!Array.isArray(option?.dateEnum) || option.dateEnum.length < 1) {
    return false;
  }
  return !option.dateEnum.includes(normalizedGranularity);
};

const dateGranularityENMap: { [key: string]: string } = {
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
};

const dateGranularityCNMap: { [key: string]: string } = {
  daily: '日粒度',
  weekly: '周粒度',
  monthly: '月粒度',
};

// 获取当前选项禁用提示文案
export const currentOptionsDisabledTip = (enabledDateEnum: string[], isEN: Boolean) => {
  if (!enabledDateEnum?.length) return;

  const currentLocaleDateEnum = isEN
    ? enabledDateEnum?.map((item) => dateGranularityENMap[item])
    : enabledDateEnum?.map((item) => dateGranularityCNMap[item]);

  if (!currentLocaleDateEnum?.filter(Boolean)?.length) return;

  const granularityStr = currentLocaleDateEnum?.join(isEN ? ' or ' : '或');

  return isEN ? `Please select ${granularityStr} granularity` : `请选择${granularityStr}`;
};
